<template>
  <!-- 排序组件 -->
  <div class="preview">
    <div class="preview-box">
      <div class="sort-header">
        <div class="sort-title">发布预览</div>
        <img alt="" @click="closeDialog" class="sort-close" :src="g_imgSrc.delete" />
      </div>
      <div class="sort-body" v-loading="bottonLoading">
        <div class="goBack cursor-style" @click="closePreview">
          <i class="el-icon-arrow-left" />
          返回
        </div>
        <div class="notice-body">
          <div class="title-header">
            仅支持给管理员和操作员发送预览，且被发送对象须关注相关公众号
          </div>
          <div class="title-footer">
            预览功能仅用于公众号查看群发效果，不适用于公众传播。图文消息和视频消息的预览链接会在短期内失效。
          </div>
          <div class="title-body">
            <div class="input-box">
              <input
                v-model="currentValue"
                size="small"
                class="input-style"
                placeholder="可输入多个微信号，按回车分隔"
                @keyup.enter="submit"
              />
            </div>
            <el-button class="confirm" type="primary" @click="submit">确认</el-button>
          </div>
          <div class="wecaht_list">
            <span :key="index + item" class="input-item" v-for="(item, index) in inputArr">
              <span class="input-word">{{ item.value }}</span>
              <i class="el-icon-circle-close cursor-style" @click="deleteValue(index)" />
            </span>
          </div>
        </div>
      </div>
      <div class="sort-footer">
        <el-button
          type="primary"
          class="sort-btn sure"
          :disabled="publishStatus"
          :loading="bottonLoading"
          @click="publish"
        >
          提交
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { preViewWechatMessageApi } from '@/api/releaseManagement.js';
export default {
  name: 'Preview',
  props: ['articleList', 'app_id'],
  data() {
    return {
      inputArr: [], // 输入列表
      currentValue: '', // 当前输入值
      bottonLoading: false, // 确定发布的loading
    };
  },
  computed: {
    publishStatus() {
      if (this.inputArr.length === 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    // 关闭所有弹窗
    closeDialog() {
      this.cleanAll();
      this.$emit('closeDialog', false);
    },
    // 关闭预览
    closePreview() {
      this.cleanAll();
      this.$emit('closePreview', false);
    },
    // 回车时记录输入框的值
    submit() {
      if (!this.currentValue) {
        return;
      }
      let same = false;
      this.inputArr.forEach((item) => {
        if (item.value === this.currentValue) {
          same = true;
        }
      });
      if (same) {
        this.$message(`${this.currentValue} 微信号已输入，请勿重复输入`);
        return;
      }
      this.inputArr.push({ value: this.currentValue });
      this.currentValue = '';
    },
    // 删除按钮
    deleteValue(index) {
      this.inputArr.splice(index, 1);
    },
    // 失去焦点时，清空输入框
    cleanValue() {
      this.currentValue = '';
    },
    cleanAll() {
      this.currentValue = '';
      this.inputArr = [];
    },
    // 确定时，传回预览结果
    publish() {
      this.bottonLoading = true;
      const wxId = this.inputArr.map((item) => item.value);
      const artId = this.articleList.map((item) => item.art_id);
      const form = {
        wx_ids: wxId,
        app_id: this.app_id,
        art_ids: artId,
      };
      preViewWechatMessageApi(form)
        .then((res) => {
          this.bottonLoading = false;
          this.$message.success('发布预览成功!');
          form.media_id = res.media_id;
          this.$emit('preViewWechat', form);
        })
        .catch((e) => {
          this.bottonLoading = false;
          this.$message.error(e.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.preview {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // position: relative;
  // font-family: PingFangSC-Regular;
  // color: #303133;
  // font-size: 16px;
  // background: rgba(0, 0, 0, 0.65);
  .preview-box {
    width: 968px;
    height: 808px;
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 8px;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
    box-shadow: 0 2px 12px 0;
    position: relative;
    .sort-header {
      height: 28px;
      line-height: 28px;
      margin-bottom: 16px;
      .sort-title {
        width: 100px;
        float: left;
      }
      .sort-close {
        cursor: pointer;
        width: 18px;
        height: 18px;
        float: right;
      }
    }
    .sort-body {
      .goBack {
        margin-top: 24px;
        text-align: left;
        color: #606266;
      }
      .goBack:hover {
        color: #2f96ff;
      }
      .notice-body {
        margin: 41px 60px 0px 60px;
        .title-header {
          color: #303133;
          margin-bottom: 16px;
        }
        .title-body {
          overflow-x: hidden;
          overflow-y: auto;
          // max-height: 400px;
          display: flex;
          .confirm {
            width: 100px;
          }
          .input-box {
            flex: 1;
            border: 2px solid rgba(0, 0, 0, 0.08);
            border-radius: 8px;
            width: 100%;
            padding: 0 10px 10px;
            display: flex;
            flex-wrap: wrap;
            .input-style {
              font-size: 16px;
              border: none;
              background: none;
              // height: 36px;
              // line-height: 36px;
              flex: 1;
              margin-top: 10px;
              outline: none;
            }
            .input-style::placeholder {
              color: #909399;
            }
            .input-style:focus {
              border: none;
            }
          }
        }
        .title-footer {
          margin: 16px 0;
          color: #909399;
        }
      }
    }
    .sort-footer {
      width: 100%;
      height: 48px;
      text-align: center;
      // margin-top: 24px;
      position: absolute;
      bottom: 24px;
      left: 0px;
      .sort-btn {
        width: 128px;
        height: 48px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
      }
      .cancel {
        border: 1px solid #dcdfe6;
        background: #ffffff;
        color: #606266;
      }
      .sure {
        border: none;
        color: #ffffff;
        background: #2f96ff;
      }
      .sort-btn:disabled {
        border: 1px solid #dcdfe6;
        color: #c0c4cc;
        background: #ffffff;
      }
      .el-button + .el-button {
        margin-left: 24px;
      }
    }
    .release-el-form-item {
      .el-form-item__label {
        font-weight: bold;
      }
    }
  }
  .right-explanation {
    margin-bottom: 20px;
  }
  .sort-date ::v-deep .el-input__inner {
    width: 100%;
  }
}
.cursor-style {
  cursor: pointer;
}
.wecaht_list {
  border: 2px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  margin-top: 10px;
  height: 200px;
  padding: 10px;
  overflow: auto;
  .input-item {
    height: 36px;
    line-height: 29px;
    background-color: #eee;
    padding: 5px;
    margin-right: 10px;
    margin-top: 10px;
    white-space: nowrap;
    border-radius: 4px;
  }
}
@media (max-height: 900px) {
  .preview-box {
    height: 620px !important;
    .left-list {
      height: 210px !important;
    }
  }
}
</style>
